module.exports = __webpack_public_path__ + "img/contact_4.ed1186b5.png";